<div class="no-property-container">
  <!-- <div class="no-property-animation">
    <svg width="90" height="90" viewBox="0 0 64 64">
      <g>
        <rect x="16" y="32" width="32" height="20" fill="#ffe082">
          <animate attributeName="y" values="32;30;32" dur="1.2s" repeatCount="indefinite"/>
        </rect>
        <polygon points="32,16 12,32 52,32" fill="#90caf9">
          <animate attributeName="points" values="32,16 12,32 52,32;32,14 12,30 52,30;32,16 12,32 52,32" dur="1.2s" repeatCount="indefinite"/>
        </polygon>
        <rect x="28" y="42" width="8" height="10" fill="#bcaaa4"/>
        <rect x="20" y="36" width="6" height="6" fill="#fff"/>
        <rect x="38" y="36" width="6" height="6" fill="#fff"/>
      </g>
    </svg>
    <div class="floating-key">
      <svg width="32" height="32" viewBox="0 0 32 32">
        <circle cx="22" cy="10" r="6" fill="#90caf9"/>
        <rect x="8" y="14" width="12" height="4" rx="2" fill="#bcaaa4"/>
        <rect x="6" y="16" width="4" height="2" rx="1" fill="#bcaaa4"/>
      </svg>
    </div>
  </div> -->
  <div class="no-property-text">{{message}}</div>
</div>
